// extracted by extract-css-chunks-webpack-plugin
module.exports = {"error-message":"error-message","error-message-wrapper":"error-message-wrapper","img-error-icon":"img-error-icon"};